import { createPortal } from "react-dom";
import { useEffect } from "react";

import closeIcon from "../../image/closeIcon.svg";
import arrowRight from "../../image/arrowRight.svg";
import styles from "./ImageGalleryModal.module.scss";

type GalleryImage = {
  src: string;
  alt?: string;
};

interface ImageGalleryModalProps {
  images: GalleryImage[];
  currentIndex: number;
  onClose: () => void;
  onPrev: () => void;
  onNext: () => void;
}

export const ImageGalleryModal = ({
  images,
  currentIndex,
  onClose,
  onPrev,
  onNext,
}: ImageGalleryModalProps) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    };

    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [onClose, onPrev, onNext]);

  if (!images.length) return null;

  return createPortal(
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.wrapper}>
          <button
            className={`${styles.arrow} ${styles.arrowLeft}`}
            onClick={onPrev}
            aria-label="previous image"
          >
            <img
              className={`${styles.btnIcon} ${styles.btnIconRotated}`}
              src={arrowRight}
              alt="Стрелка влево"
            />
          </button>

          <div className={styles.imageWrapper}>
            <img
              className={styles.image}
              src={images[currentIndex].src}
              alt={images[currentIndex].alt || `image ${currentIndex + 1}`}
            />

            <button
              className={styles.closeBtn}
              onClick={onClose}
              aria-label="close"
            >
              <img
                className={styles.btnIcon}
                src={closeIcon}
                alt="Иконка закрытия"
              />
            </button>
          </div>

          <button
            className={`${styles.arrow} ${styles.arrowRight}`}
            onClick={onNext}
            aria-label="next image"
          >
            <img
              className={styles.btnIcon}
              src={arrowRight}
              alt="Стрелка вправо"
            />
          </button>
        </div>

        <div className={styles.counter}>
          {currentIndex + 1} / {images.length}
        </div>
      </div>
    </div>,
    document.body
  );
};
